/* eslint-disable react/style-prop-object */
/*import React, { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import { useSelector } from "react-redux";
import Loader from "../../../../Helpers/Loader/Loader";
import trans from "../../../../../utils";
import {
	useGetAllGroupsQuery,
	useLazyGetSubGroupsByGroupQuery,
} from "../../../../../Redux/service/Groups/GroupsBack";
import { TreeSelect } from "antd";

export default function GroupsCheckTree() {
	const inf = useSelector((state) => state.users.user);
	const { data: AllUsers = [], isLoading } = useGetAllGroupsQuery(inf?.id, {
		skip: !inf?.id,
	}); // default to an empty array
	const [triggerGetChildUsers] = useLazyGetSubGroupsByGroupQuery();
	const [childDataMap, setChildDataMap] = useState({});
	const [subchildDataMap, setSubChildDataMap] = useState({});
	const [expandedParents, setExpandedParents] = useState({});
	const [expandedChilds, setExpandedChilds] = useState({});
	const [childIds, setChildIds] = useState([]);
	const [toggle, setToggle] = useState(false);
	const [childtoggle, setChildToggle] = useState(false);
	const [isOpen, setIsOpen] = useState(false);

	const [treeData, setTreeData] = useState([
		{
			value: "parent 1",
			title: "parent 1",
			children: [
				{
					value: "parent 1-0",
					title: "parent 1-0",
					children: [
						{
							value: "leaf1",
							title: "my leaf",
						},
						{
							value: "leaf2",
							title: "your leaf",
						},
					],
				},
				{
					value: "parent 1-1",
					title: "parent 1-1",
					children: [
						{
							value: "sss",
							title: <b style={{ color: "#08c" }}>sss</b>,
						},
					],
				},
			],
		},
	]);
	useEffect(() => {
		const buildTree = (nodes) => {
			return nodes.map((node) => ({
				value: node.id,
				title: node.name,
				children:
					node.children && node.children.length > 0
						? buildTree(node.children)
						: undefined,
			}));
		};

		if (AllUsers && AllUsers.length > 0) {
			const newTreeData = buildTree(AllUsers);
			setTreeData(newTreeData);
		}
	}, [AllUsers]);

	const [value, setValue] = useState();

	const {
		parentCheck,
		setParentCheck,
		childCheck,
		setChildCheck,
		ObjectUsersearchQuery,
		setObjectUserSearchQuery,
		subchildCheck,
		setSubChildCheck,
	} = useContext(filtrationcontext);

	// Ensure AllUsers is an array before filtering
	const Branches = Array.isArray(AllUsers)
		? AllUsers.filter((user) => user.administrator === false)
		: [];

	const handleParentCheckClick = (id) => (e) => {
		const isChecked = e.target.checked;
		setParentCheck((prev) => {
			const updatedParentCheck = isChecked
				? [...prev, id]
				: prev?.filter((item) => item !== id);
			return updatedParentCheck;
		});
	};

	const handleChildCheckClick = (id) => (e) => {
		const isChecked = e.target.checked;
		setChildCheck((prev) => {
			const updatedChildCheck = isChecked
				? [...prev, id]
				: prev?.filter((item) => item !== id);
			return updatedChildCheck;
		});
	};

	const handleSubChildCheckClick = (id) => (e) => {
		const isChecked = e.target.checked;
		setSubChildCheck((prev) => {
			const updatedSubChildCheck = isChecked
				? [...prev, id]
				: prev?.filter((item) => item !== id);
			return updatedSubChildCheck;
		});
	};
	const handleImageClick = (id) => async () => {
		try {
			if (!expandedParents[id]) {
				const data = await triggerGetChildUsers(id).unwrap();
				setChildDataMap((prevMap) => ({
					...prevMap,
					[id]: data,
				}));
			}

			setExpandedParents((prev) => ({
				...prev,
				[id]: !prev[id],
			}));
			setToggle(!toggle);
		} catch (error) {
			console.error("Failed to fetch child users", error);
		}
	};
	const handleSubImageClick = (id) => async () => {
		try {
			if (!expandedChilds[id]) {
				const data = await triggerGetChildUsers(id).unwrap();
				setSubChildDataMap((prevMap) => ({
					...prevMap,
					[id]: data,
				}));
			}

			setExpandedChilds((prev) => ({
				...prev,
				[id]: !prev[id],
			}));
			setChildIds((prev) => {
				if (!prev.includes(id)) {
					return [...prev, id];
				}
				return prev.filter((childId) => childId !== id);
			});
			setChildToggle(!childtoggle);
		} catch (error) {
			console.error("Failed to fetch child users", error);
		}
	};
	const filteredBranches = Branches?.filter((branch) => {
		const isParentMatch = branch.name
			.toLowerCase()
			.includes(ObjectUsersearchQuery.toLowerCase());

		const isChildMatch = childDataMap[branch.id]?.some((child) =>
			child.name.toLowerCase().includes(ObjectUsersearchQuery.toLowerCase())
		);

		return isParentMatch || isChildMatch;
	});

	if (isLoading)
		return (
			<div>
				<Loader />
			</div>
		);
	if (!AllUsers)
		return (
			<div className="my-5 p-5">
				<div className="text-center text-success fs-16 fw-700">
					{trans("No data shown")}
				</div>
			</div>
		);
	const lang = localStorage.getItem("lang") || "en";

	const onChange = (newValue) => {
		setParentCheck(newValue);
	};
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	return (
		<TreeSelect
			showSearch
			style={{ width: "100%" }}
			value={value}
			styles={{
				popup: { root: { maxHeight: 400, overflow: "auto" } },
			}}
			placeholder="Please select"
			allowClear
			multiple
			treeDefaultExpandAll
			treeCheckable
			treeCheckStrictly
			showCheckedStrategy="SHOW_ALL"
			maxTagCount="responsive"
			onChange={onChange}
			filterTreeNode={(input, treeNode) =>
				typeof treeNode.title === "string"
					? treeNode.title.toLowerCase().includes(input.toLowerCase())
					: // If the title is JSX (like <b>), extract its content
					  treeNode.title?.props?.children
							?.toLowerCase?.()
							?.includes(input.toLowerCase())
			}
			onDropdownVisibleChange={handleDropdownVisibleChange}
			treeData={treeData}
			open={isOpen}
		/>
	);
}*/

/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import { useSelector } from "react-redux";
import Loader from "../../../../Helpers/Loader/Loader";
import trans from "../../../../../utils";
import {
	useGetAllGroupsQuery,
	useLazyGetSubGroupsByGroupQuery,
} from "../../../../../Redux/service/Groups/GroupsBack";
import { Tree } from "antd";
import { keyBy } from "lodash";
import { object } from "yup";

export default function GroupsChecktree() {
	const inf = useSelector((state) => state.users.user);
	const {
		data: AllUsers = [],
		isLoading,
		refetch,
	} = useGetAllGroupsQuery(inf?.id, {
		skip: !inf?.id,
	}); // default to an empty array
	const [triggerGetChildUsers] = useLazyGetSubGroupsByGroupQuery();
	const [childDataMap, setChildDataMap] = useState({});
	const [expandedParents, setExpandedParents] = useState({});
	const [toggle, setToggle] = useState(false);
	const [treeData, setTreeData] = useState();
	const [expandedKeys, setExpandedKeys] = useState([]);

	const {
		parentCheck,
		setParentCheck,
		childCheck,
		setChildCheck,
		ObjectUsersearchQuery,
		setObjectUserSearchQuery,
	} = useContext(filtrationcontext);
	useEffect(() => {
		return () => {
			setObjectUserSearchQuery(null);
		};
	}, [setObjectUserSearchQuery]);
	console.log("AllUsers", AllUsers);
	// Ensure AllUsers is an array before filtering
	const Branches = Array.isArray(AllUsers)
		? AllUsers.filter((user) => user.administrator === false)
		: [];

	useEffect(() => {
		const buildTree = (nodes) => {
			return nodes?.map((node) => ({
				value: node.id,
				key: node.id, // Ensure each node has a unique key
				title: node.name,
				children:
					node.children && node.children.length > 0
						? buildTree(node.children)
						: undefined,
			}));
		};

		if (AllUsers && AllUsers.length > 0) {
			const newTreeData = buildTree(AllUsers);
			setTreeData(newTreeData);
		}
	}, [AllUsers]);
	const handleParentCheckClick = (id) => (e) => {
		const isChecked = e.target.checked;
		setParentCheck((prev) => {
			const updatedParentCheck = isChecked
				? [...prev, id]
				: prev?.filter((item) => item !== id);
			return updatedParentCheck;
		});
	};

	const handleChildCheckClick = (id) => (e) => {
		const isChecked = e.target.checked;
		setChildCheck((prev) => {
			const updatedChildCheck = isChecked
				? [...prev, id]
				: prev?.filter((item) => item !== id);
			return updatedChildCheck;
		});
	};

	const handleImageClick = (id) => async () => {
		try {
			if (!expandedParents[id]) {
				const data = await triggerGetChildUsers(id).unwrap();
				setChildDataMap((prevMap) => ({
					...prevMap,
					[id]: data,
				}));
			}

			setExpandedParents((prev) => ({
				...prev,
				[id]: !prev[id],
			}));
			setToggle(!toggle);
		} catch (error) {
			console.error("Failed to fetch child users", error);
		}
	};

	const filteredBranches = Branches?.filter((branch) => {
		const isParentMatch = branch.name
			.toLowerCase()
			.includes(ObjectUsersearchQuery.toLowerCase());

		const isChildMatch = childDataMap[branch.id]?.some((child) =>
			child.name.toLowerCase().includes(ObjectUsersearchQuery.toLowerCase())
		);

		return isParentMatch || isChildMatch;
	});
	const onChange = (newValue) => {
		setParentCheck(newValue?.checked);
	};
	const handleExpand = (keys) => {
		setExpandedKeys(keys);
	};

	if (isLoading)
		return (
			<div>
				<Loader />
			</div>
		);
	if (!AllUsers)
		return (
			<div className="my-5 p-5">
				<div className="text-center text-success fs-16 fw-700">
					{trans("No data shown")}
				</div>
			</div>
		);
	const lang = localStorage.getItem("lang") || "en";
	console.log("ObjectUsersearchQuery", ObjectUsersearchQuery);
	const filterTree = (nodes, query) => {
		const filtered = [];
		console.log("nodessFIlter", nodes);

		for (const node of nodes) {
			const { title, value, children } = node;
			const lowerLabel = title.toLowerCase();
			const lowerQuery = query.toLowerCase();

			if (lowerLabel.includes(lowerQuery)) {
				filtered.push(node); // Match found
			} else if (children) {
				const filteredChildren = filterTree(children, query);
				if (filteredChildren.length > 0) {
					filtered.push({ ...node, children: filteredChildren }); // Keep parents of matched children
				}
			}
		}

		return filtered;
	};
	const filteredTreeData = ObjectUsersearchQuery
		? filterTree(treeData, ObjectUsersearchQuery)
		: treeData;

	console.log("treedata", filteredTreeData);
	console.log("search", ObjectUsersearchQuery);
	const getAllKeys = (nodes) => {
		let keys = [];

		nodes?.forEach((node) => {
			keys.push(node.key); // include this node's key

			if (Array.isArray(node.children)) {
				keys = keys.concat(getAllKeys(node.children)); // include all descendants
			}
		});

		return keys;
	};

	<Tree
		checkable
		checkStrictly
		treeData={filteredTreeData}
		onCheck={onChange}
		expandedKeys={
			ObjectUsersearchQuery && ObjectUsersearchQuery?.trim() !== ""
				? getAllKeys(filteredTreeData)
				: []
		}
		autoExpandParent={true}
	/>;

	return (
		<>
			<Searchbar
				style="search-dark input-group"
				width="285px"
				path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
				placeholder={trans("Search")}
				value={ObjectUsersearchQuery}
				onChange={(e) => setObjectUserSearchQuery(e.target.value)}
			/>

			{AllUsers.length === 0 ? (
				<div className="my-5 p-5">
					<div className="text-center text-success fs-16 fw-700">
						{trans("No data shown")}
					</div>
				</div>
			) : (
				<div className="users-filter mt-3">
					<Tree
						checkable
						checkStrictly
						treeData={filteredTreeData}
						onCheck={onChange}
						expandedKeys={
							ObjectUsersearchQuery !== "" &&
							ObjectUsersearchQuery?.trim() !== ""
								? getAllKeys(filteredTreeData)
								: expandedKeys
						}
						onExpand={handleExpand}
						checkedKeys={parentCheck.map((i) => i)}
						selectable={false} // disables selection
						titleRender={(nodeData) => <span>{nodeData.title}</span>}
					/>
				</div>
			)}
		</>
	);
}
